import { endpoint } from './default';

const getProblemset = (series, name, ver) => endpoint.get(`/problemset/${series}/${name}/${ver}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getProblemsetById = (series, name, ver, pid) => endpoint.get(`/problemset/${series}/${name}/${ver}/problem_id/${pid}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getProblemsetByWeek = (series, name, ver, week) => endpoint.get(`/problemset/${series}/${name}/${ver}/week_id/${week}`, {
  params: {
    tag: 'CodingWizard',
  },
});

const getProblemInfoById = (pId) => endpoint.get(`/problemset/problem_id/${pId}`, {
  params: {
    tag: 'CodingWizard',
  },
});

export {
  getProblemset,
  getProblemsetById,
  getProblemsetByWeek,
  getProblemInfoById,
};
